var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.834 16.583L20.2507 13.833L25.7507 16.583L31.5284 14.1071C31.5981 14.0772 31.6742 14.0651 31.7498 14.0718C31.8254 14.0786 31.8981 14.104 31.9614 14.1458C32.0248 14.1876 32.0767 14.2445 32.1127 14.3113C32.1486 14.3782 32.1674 14.4529 32.1673 14.5288V29.4163L25.7507 32.1663L20.2507 29.4163L14.4729 31.8923C14.4032 31.9222 14.3271 31.9343 14.2515 31.9275C14.1759 31.9208 14.1032 31.8953 14.0399 31.8535C13.9765 31.8117 13.9246 31.7549 13.8886 31.688C13.8527 31.6212 13.8339 31.5465 13.834 31.4706V16.583ZM26.6673 29.7784L30.334 28.2073V16.6133L26.6673 18.1844V29.7784ZM24.834 29.6583V18.1743L21.1673 16.341V27.825L24.834 29.6583ZM19.334 27.8149V16.2209L15.6673 17.7921V29.3861L19.334 27.8149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMap);
export default __webpack_public_path__ + "static/media/googleMap.836a265fd9f30493e61e032efcd6a523.svg";
export { ForwardRef as ReactComponent };